module.exports = __webpack_public_path__ + "img/volume-off.0bc16316.svg";